import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { lessons: Array, courses: Array }
  static targets = ["courseSelect", "lessonToggle", "lessonLabel", "lessonList"]

  connect() {
    // lessonToggle starts disabled via HTML attribute
  }

  updateLessons() {
    const selectedCourseIds = Array.from(this.courseSelectTarget.selectedOptions).map(o => parseInt(o.value))

    if (selectedCourseIds.length === 0) {
      this.lessonListTarget.innerHTML = ""
      this.lessonToggleTarget.disabled = true
      this.lessonLabelTarget.textContent = "Select Lessons"
      return
    }

    const checkedIds = new Set(
      Array.from(this.lessonListTarget.querySelectorAll("input:checked")).map(cb => cb.value)
    )

    const validLessons = this.lessonsValue.filter(l => selectedCourseIds.includes(l.course_id))

    const grouped = this.coursesValue
      .filter(c => selectedCourseIds.includes(c.id))
      .map(c => ({ course: c, lessons: validLessons.filter(l => l.course_id === c.id) }))
      .filter(g => g.lessons.length > 0)

    this.lessonListTarget.innerHTML = grouped.map((g, i) => {
      const videos = g.lessons.filter(l => l.primary_type === "video")
      const worksheets = g.lessons.filter(l => l.primary_type === "worksheet")
      const other = g.lessons.filter(l => l.primary_type !== "video" && l.primary_type !== "worksheet")

      const renderCheckboxes = (lessons) => lessons.map(l => `
        <label class="d-flex align-items-center gap-2 py-1 px-2" for="lesson_${l.id}">
          <input type="checkbox" name="lesson_ids[]" value="${l.id}" id="lesson_${l.id}"${checkedIds.has(String(l.id)) ? " checked" : ""}>
          <span class="small">${this.#esc(l.title)}</span>
        </label>
      `).join("")

      const renderColumn = (label, lessons) => lessons.length === 0 ? "" : `
        <div class="col-6">
          <div class="fw-bold text-muted small mb-1">${label}</div>
          ${renderCheckboxes(lessons)}
        </div>
      `

      return `
        ${i > 0 ? '<li><hr class="dropdown-divider"></li>' : ""}
        <li class="dropdown-header fw-bold fs-2">${this.#esc(g.course.title)}</li>
        <li class="px-3 py-2">
          <div class="row">
            ${renderColumn("Video Lessons", videos)}
            ${renderColumn("Worksheet Lessons", worksheets)}
          </div>
          ${other.length > 0 ? `
            <div class="mt-2">
              <div class="fw-bold text-muted small mb-1">Other Lessons</div>
              ${renderCheckboxes(other)}
            </div>
          ` : ""}
        </li>
      `
    }).join("")

    this.lessonToggleTarget.disabled = false
    this.#syncLabel()
  }

  updateLabel() {
    this.#syncLabel()
  }

  #syncLabel() {
    const count = this.lessonListTarget.querySelectorAll("input:checked").length
    this.lessonLabelTarget.textContent = count > 0 ? `${count} lesson${count === 1 ? "" : "s"} selected` : "Select Lessons"
  }

  #esc(str) {
    return str.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;")
  }
}
